export default "__VITE_ASSET__CcgxcPc___"